<template>
    <ul class="nav_breadcrumbs">
        <li><router-link to="/modules/home">{{lang.LBL_HOME}}</router-link></li>
        <li><router-link to="/modules/emailtemplates/edit">{{lang.LBL_ADD_TEMPLATE}}</router-link></li>
        <li><router-link to="/modules/emailtemplates">{{lang.LBL_VIEW_TEMPLATE}}</router-link></li>
    </ul>
</template>
<script>
import lang from "@/views/modules/EmailTemplates/language/en";
export default {
    name: "breadcrumbs",
    data() {
        return {
            lang:[],
           
        }
     },
     mounted() {
        this.lang = lang;
       
    },
    methods:{
       
    }
}
</script>
